import { connect } from 'react-redux';

import { getMembership } from '@techstyle/react-accounts';

import {
  getDiscounts,
  getExcludedProductTypesForAfterpay,
  getGwpProduct,
  getGwpPromo,
  getMembershipCartItem,
  getOrderDiscounts,
  getOrderRetailDeliveryFee,
  getStoreCredits,
  hasCustomizableItems,
  hasPreorderItems,
  isEmpVip,
  isGwpApplied,
  isNMP,
  getActiveGiftCertCredits,
} from '../../utils/selectors';
import withMembershipPrice from '../../utils/withMembershipPrice';

import TotalPriceSummary from './TotalPriceSummary';

const mapStateToProps = (state, ownProps) => {
  return {
    afterpayExcludedProductType: getExcludedProductTypesForAfterpay(state),
    giftCardCredits: getActiveGiftCertCredits(state),
    discounts: getDiscounts(state, ownProps),
    gwpPromo: getGwpPromo(state, ownProps),
    gwpProduct: getGwpProduct(state, ownProps),
    hasCustomizableItems: hasCustomizableItems(state),
    hasPreorderItems: hasPreorderItems(state),
    isBorderfreeCustomer: state.borderfree.isBorderfreeCustomer,
    isDowngradedMember: getMembership(state).isDowngraded,
    isOrderPage: !!ownProps?.order,
    isEU: state.domain.tld !== '.com',
    isEmpVip: isEmpVip(state),
    isGwpApplied: isGwpApplied(state, ownProps),
    isInfluencer: !!state.customer.isInfluencer,
    isLead: getMembership(state).isLead,
    isPaygo: getMembership(state).isPaygo,
    isNMP: isNMP(state),
    isUS: state.domain.tld === '.com',
    isVip: getMembership(state).isVip,
    membershipItem: getMembershipCartItem(state, ownProps),
    order: ownProps.order || state.checkout,
    orderDiscounts: getOrderDiscounts(state, ownProps),
    registrationDate: getMembership(state).dateAdded,
    retailDeliveryFee: getOrderRetailDeliveryFee(state, ownProps),
    storeCredits: getStoreCredits(state, ownProps),
    tld: state.domain.tld,
  };
};

export default connect(mapStateToProps)(withMembershipPrice(TotalPriceSummary));
